<template>
	<div>
		<Hrader :idShwo="6" @skipCompents="landingClcik"></Hrader>
		<div style="height: 70px"></div>
		<div>
			<img src="../../assets/about_slices/Mask group@2x.png" style="width: 100%; height: auto" />
		</div>

		<div class="rectangle" style="margin-top: -10px">
			<div class="rectangle-with">
				<div class="flex-rectange">
					<div>
						<img src="../../assets/recycling_slices/Vector@2x.png" style="width: 12px; height: 13px" />
					</div>
					<div class="current-recy">当前位置 : 关于我们</div>
				</div>
			</div>
		</div>
	</div>

	<div class="cooperation">
		<div class="assets-cooptaioc">
			<div class="flex-assets-copptaioc">
				<div class="image-assets">
					<img src="../../assets/about_slices/Group 1893@2x.png" style="width: 263px; height: 61px;" />
					<div class="image-tilte">京卡收是大连辛壬葵网络科技服务有限公司基于互联网研发出来的专注于卡券回收服务的创新型服务平台，致力于为用户提供安全、便捷、高效的服务，让每一张闲置卡券都发挥价值。
					</div>
				</div>
				<div class="images-padd">
					<img src="../../assets/about_slices/Group 1983@2x.png" style="width: 100%; height: 264px" />
				</div>
			</div>
			<div class="platfor-image">
				<div style="padding-top: 27px; margin-left: 8px">
					主营业务
				</div>
			</div>
			<div class="flex-row">
				<div class="img-row" v-for="(item,index) in lisData" :key="index">
					<img :src="item.image" style="width: 128px; height: 128px;" />
					<div class="row-title">{{ item.title }}</div>
					<div class="row-text">回收</div>
				</div>
			</div>

			<div class="flex-row-bj">
				<div class="cart-bj" v-for="(item,index) in dataListObj" :key="index">
					<div class="title-cart">{{item.title}}</div>
					<div class="rows-aboutd">{{item.text}}</div>
				</div>
			</div>

			<div class="bj-fle-width">
				<div class="title-rows">愿景</div>
				<div class="text-rows" style="font-weight: 400;">成为全国领先的卡券回收平台，为客户创造价值，为社会带来可持续的环保效益。 未来，将继续创新技术、优化服务，为客户提供更优质的卡券回收体验。</div>
			</div>

			<div class="row-list">
				<img src="../../assets/about_slices/Group 1834@2x.png" style="margin: auto; width: 711px; height: 154px;" />
			</div>


			<div class="bordered-box">
				<div class="text-box">
					<div>1.关注微信公众号：京卡收，点击卡券回收;</div>
					<div>2.微信小程序搜索：京卡收	</div>
					<div>3.网站搜索京卡收官网（https://www.jingkashou.com）；进入平台首页，找到对应卡券；选择正确的面值，输入充值卡的卡号和卡密，点击立即兑换提交；等待片刻回收成功，余额到账。	</div>
				</div>
			</div>
     
		 <div style="height: 56px;"></div>
		 
		</div>
	</div>

	<el-dialog v-model="dialogVisible" :show-close="false" width="627">
		<div class="flex">
			<div>
				<img src="@/assets/Group 1876@2x.png" style="width: 222px; height: 260px" />
			</div>
			<div style="margin-left: 25px">
				<div class="flex">
					<div class="flex-title">客服热线</div>
					<img src="@/assets/assets-push/Vector@2x (24).png" style="margin-top: -7px; width: 23px; height: 23px" />
				</div>
				<div class="electricity">400-696-5550</div>
				<div class="title-flex">客服时间：周一至周日 09:00-23:00</div>
				<div class="title-flex">联系邮箱：jingkashou@163.com</div>
				<div class="title-flex">联系地址：辽宁省大连市中山区桃仙街</div>
				<div class="title-flex">商务电活：19118810421</div>

				<div class="close" @click="dialogVisible = false">关闭</div>
			</div>
		</div>
		<template #footer>
			<div class="service-hotline">
				<img src="@/assets/assets-push/image 72@2x.png" class="service-padd" />
			</div>
		</template>
	</el-dialog>

	<Tabr></Tabr>
	<div>
		<Customer></Customer>
	</div>
</template>

<script setup>
	import {
		ref,
		onMounted
	} from 'vue';
	import {
		useRouter
	} from 'vue-router';
	import Tabr from '@/components/tabr.vue';
	import Customer from '@/components/customer.vue';
	import Landing from '@/components/landing.vue';
	import Hrader from '@/components/header.vue';
	import {
		cardList,
		categoryList
	} from '@/utils/api.js';
	let router = useRouter();
	const dialogVisible = ref(false);
	let showDetails = ref(false);
	let idsIndex = ref(0);
	let indexNumber = ref(1);
	let idsIndex1 = ref(0);
	let indexNumber1 = ref(1);
	let idsIndex2 = ref(0);
	let indexNumber2 = ref(1);
	let idsIndex3 = ref(0);
	let indexNumber3 = ref(1);
	let ids = ref(7);
	let listData = ref([]);
	let listDataCard = ref([]);
	let dataListSkip = ref([]);
	let dataSkipList = ref([]);
	let marListRef = ref([]);


	let dataListObj = ref([{
			title: '电商卡',
			text: '京东e卡、京东钢镚、苏宁易购礼品卡、壹钱包(壹卡会)、万里通积分卡、天猫超市卡/享淘卡、每日优鲜、天猫元宝(福宝)、苏宁铜板、苏宁小店礼品卡、叮咚买菜礼品卡、盒马鲜生礼品卡、唯品会礼品卡。'
		},
		{
			title: '商超卡',
			text: '沃尔玛卡，大润发卡，永辉超市卡，1号店礼品卡，华润万家卡，麦德龙礼品卡，世纪联华卡，家乐福礼品卡。'
		},
		{
			title: '加油卡',
			text: '中国石油、中国石化。'
		},
		{
			title: '话费卡',
			text: '中国移动、中国联通、中国电信。'
		},
		{
			title: '游戏卡',
			text: '苹果充值卡、Q币一卡通、完美一卡通、天宏一卡通、易充天宏卡、易充天宏卡、天宏畅付卡、网易一卡通、巨人一卡通（征途卡）、搜狐一卡通、骏网一卡通、金山一卡通、汇元易付卡。'
		},
		{
			title: '美食券',
			text: '美团外卖券、必胜客代金券、哈根达斯代金券等。'
		},
		{
			title: '出行券',
			text: '滴滴快车券、滴滴专车券、滴滴快车充值卡。'
		},
		{
			title: '影音券',
			text: '爱奇艺会员，腾讯视频会员，优酷视频，喜马拉雅等。'
		},
	]);

	let lisData = ref([{
			image: require('../../assets/about_slices/Group 1990@2x.png'),
			title: '电商购物卡'
		},
		{
			image: require('@/assets/about_slices/Group 1989@2x.png'),
			title: '商超礼品卡'
		},
		{
			image: require('@/assets/about_slices/Group 1986@2x.png'),
			title: '美食卡券'
		},
		{
			image: require('@/assets/about_slices/Group 1985@2x.png'),
			title: '加油卡'
		},
		{
			image: require('@/assets/about_slices/Group 1991@2x.png'),
			title: '出行券'
		},
		{
			image: require('@/assets/about_slices/Group 1988@2x.png'),
			title: '影音券'
		},
		{
			image: require('@/assets/about_slices/Group 1987@2x.png'),
			title: '游戏卡'
		},
		{
			image: require('@/assets/about_slices/Group 1984@2x.png'),
			title: '话费卡'
		},
	])

	const skipClick = (item) => {
		console.log(item);
		router.push({
			path: item
		});
	};
	const info = async (index, item) => {
		let res = await cardList({
			categoryId: item.id
		});
		if (index == 0) {
			listData.value = res.data;
		} else if (index == 1) {
			listDataCard.value = res.data;
		} else if (index == 2) {
			dataListSkip.value = res.data;
		} else {
			dataSkipList.value = res.data;
		}
	};
	const infoList = async (item) => {
		let res = await categoryList();
		marListRef.value = res.data;
		marListRef.value.forEach((item, index) => {
			info(index, item);
		});
	};
	const reduction = () => {
		if (indexNumber.value == 1) return false;
		indexNumber.value--;
		idsIndex.value--;
	};
	const plus = () => {
		if (indexNumber.value * 6 < listDataCard.value.length) {
			indexNumber.value++;
			idsIndex.value++;
		}
	};

	const reduction2 = () => {
		if (indexNumber2.value == 1) return false;
		indexNumber2.value--;
		idsIndex2.value--;
	};
	const plus2 = () => {
		if (indexNumber2.value * 6 < listData.value.length) {
			indexNumber2.value++;
			idsIndex2.value++;
		}
	};

	const reduction1 = () => {
		if (indexNumber1.value == 1) return false;
		indexNumber1.value--;
		idsIndex1.value--;
	};

	const plus1 = () => {
		if (indexNumber1.value * 6 < dataSkipList.value.length) {
			indexNumber1.value++;
			idsIndex1.value++;
		}
	};

	const reduction3 = () => {
		if (indexNumber3.value == 1) return false;
		indexNumber3.value--;
		idsIndex3.value--;
	};

	const plus3 = () => {
		if (indexNumber3.value * 6 < dataListSkip.value.length) {
			indexNumber3.value++;
			idsIndex3.value++;
		}
	};

	onMounted(() => {
		infoList();
	});
</script>

<style lang="scss" scoped>
	.platfor-image {
		background: url('../../assets/HomeView/Group 1784@2x.png') no-repeat;
		background-size: cover;
		width: 143px;
		margin: auto;
		font-family: PingFang SC, PingFang SC;
		font-weight: 600;
		font-size: 26px;
		color: #333333;
		text-align: left;
		font-style: normal;
		text-transform: none;
		margin-top: 110px;
	}

	.flex {
		display: flex;
	}

	.align {
		align-items: center;
	}

	.justify {
		justify-content: center;
	}

	.electricity {
		font-family: PingFang SC, PingFang SC;
		font-weight: 600;
		font-size: 22px;
		color: #ff0000;
		font-style: normal;
		text-transform: none;
		margin-top: 10px;
	}

	.flex-title {
		font-family: PingFang SC, PingFang SC;
		font-weight: 600;
		font-size: 16px;
		color: #333333;
		letter-spacing: 4px;
		font-style: normal;
		text-transform: none;
	}

	.title-flex {
		font-family: PingFang SC, PingFang SC;
		font-weight: 400;
		font-size: 14px;
		color: #222222;
		font-style: normal;
		text-transform: none;
		margin-top: 14px;
	}

	.close {
		width: 135px;
		height: 42px;
		background: #ff3333;
		border-radius: 4px 4px 4px 4px;
		font-family: PingFang SC, PingFang SC;
		font-weight: 400;
		font-size: 16px;
		color: #ffffff;
		line-height: 42px;
		text-align: center;
		font-style: normal;
		text-transform: none;
		margin-top: 20px;
	}

	.close:hover {
		cursor: pointer;
	}

	.head-guidance {
		width: 100%;
		height: 70px;
		background: #ffffff;
		border-radius: 0px 0px 0px 0px;
		position: fixed;
		top: 0;
		z-index: 111;

		.head-guidance-flex {
			width: 100%;
			display: flex;
			justify-content: space-between;

			.image {
				width: 106px;
				height: 40px;
				margin-top: 15px;
				margin-left: 160px;
			}
		}

		.head-right {
			display: flex;
			margin-right: 104px;

			.head-right-flex {
				display: flex;
				align-items: center;
				margin-top: 12px;
				margin-left: 36px;

				.home-right {
					font-family: PingFang SC, PingFang SC;
					font-weight: 400;
					font-size: 16px;
					color: #333333;
					text-align: left;
					font-style: normal;
					text-transform: none;
					margin-left: 6px;
				}
			}

			.head-right-flex:hover {
				cursor: pointer;
			}

			.head-right-flex1:hover {
				cursor: pointer;
			}

			.head-right-flex1 {
				display: flex;
				align-items: center;
				padding: 11px 16px;
				background: #ff3333;
				border-radius: 74px 74px 74px 74px;
				margin-top: 13px;

				.home-right {
					font-family: PingFang SC, PingFang SC;
					font-weight: 400;
					font-size: 16px;
					color: #fff;
					text-align: left;
					font-style: normal;
					text-transform: none;
					margin-left: 6px;
				}
			}

			.frame-flex {
				height: 18px;
				border-right: 1px solid #dddddd;
				margin-top: 26px;
				margin-left: 22px;
				padding-right: 44px;
			}
		}
	}

	.cooperation {
		width: 1280px;
		margin: auto;
	}

	.assets-cooptaioc {
		background-color: #fff;
		margin-top: 21px;
		border-radius: 5px;
	}

	.flex-assets-copptaioc {
		position: relative;
		z-index: 10;
		width: 100%;
		height: 264px;
	}

	.images-padd {
		position: absolute;
		top: 0;
		left: 0;
		z-index: -1;
	}

	.flex-assets {
		margin-left: 155px;
	}

	.cooper-current {
		padding: 16px;
		padding-bottom: 40px;
		background: #fff;
		margin-top: 20px;
		border-radius: 5px;
	}

	.row-flex-assets {
		display: flex;
		margin-left: -60px;
		margin-top: 77px;
	}

	.row-flex-group {
		margin-left: 60px;
	}

	.title-group {
		width: 162px;
		height: 42px;
		background: #ff2f17;
		border-radius: 64px 64px 64px 64px;
		text-align: center;
		line-height: 42px;
		font-family: PingFang SC, PingFang SC;
		font-weight: 400;
		font-size: 16px;
		color: #ffffff;
		letter-spacing: 2px;
		font-style: normal;
		text-transform: none;
		margin: auto;
		margin-top: 50px;
	}

	.title-group:hover {
		cursor: pointer;
	}

	.service-hotline {
		position: relative;
		height: 10px;
	}

	.service-padd {
		position: absolute;
		width: 139px;
		height: 139px;
		bottom: -40px;
		right: 0;
	}

	.image-assets {
		padding-left: 81px;
		padding-top: 50px;
	}

	.image-tilte {
		width: 822px;
		font-family: PingFang SC, PingFang SC;
		font-weight: 500;
		font-size: 20px;
		color: #FFFFFF;
		font-style: normal;
		text-transform: none;
		margin-top: 20px;
	}

	.img-row {
		display: flex;
		flex-direction: column;
		align-items: center;
		width: 25%;
		margin-top: 25px;
	}

	.flex-row {
		display: flex;
		align-items: center;
		justify-content: space-between;
		flex-wrap: wrap;
		padding-top: 50px;
		margin: auto;
		width: 90%;
	}

	.row-title {
		width: 80px;
		font-family: PingFang SC, PingFang SC;
		font-weight: 600;
		font-size: 16px;
		color: #EC3925;
		text-align: center;
		font-style: normal;
		text-transform: none;
		margin-top: 20px;
	}
	
	.row-text{
		width: 80px;
		height: 42px;
		font-family: PingFang SC, PingFang SC;
		font-size: 16px;
		color: #EC3925;
		text-align: center;
		font-style: normal;
		text-transform: none;
	}

	.flex-row-bj {
		margin-left: 85px;
		display: flex;
		flex-wrap: wrap;
		margin-top: 38px;
	}

	.cart-bj {
		width: 528px;
		height: 175px;
		background: #FFF5EC;
		border-radius: 12px 12px 12px 12px;
		border: 1px solid #F1E3D6;
		margin-left: 20px;
		margin-top: 20px;
		display: flex;
		flex-direction: column;
		justify-content: center;
		align-items: center;

	}

	.title-cart {
		font-family: PingFang SC, PingFang SC;
		font-weight: 600;
		font-size: 20px;
		color: #8C5E35;
		text-align: center;
		font-style: normal;
		text-transform: none;
	}

	.rows-aboutd {
		width: 394px;
		font-family: PingFang SC, PingFang SC;
		font-weight: 400;
		font-size: 16px;
		color: #867565;
		text-align: center;
		font-style: normal;
		text-transform: none;
		margin-top: 9px;
	}

	.bj-fle-width {
		width: 953px;
		font-family: PingFang SC, PingFang SC;
		font-weight: 600;
		font-size: 24px;
		color: #8C5E35;
		text-align: center;
		font-style: normal;
		text-transform: none;
		margin: auto;
		margin-top: 90px;
	}

	.text-rows {
		font-size: 18px;
	}

	.row-list {
		margin-top: 41px;
		display: flex;
		align-content: center;
	}

	.bordered-box {
		position: relative;
		width: 1076px;
		height: 165px;
		background: #FFFFFF;
		border-radius: 12px 12px 12px 12px;
		border: 1px solid #EEEEEE;
		margin: auto;
		margin-top: 104px;
	}

	.bordered-box::before {
		content: "使用教程";
		position: absolute;
		top: -20px;
		left: 30px;
		background-color: #fff;
		width: 96px;
		height: 27px;
		font-family: FZDaHei-B02S, FZDaHei-B02S;
		font-weight: 400;
		font-size: 24px;
		color: #333333;
		text-align: left;
		font-style: normal;
		text-transform: none;
	}
	
	.text-box{
    width: 1004px;		
		font-family: PingFang SC, PingFang SC;
		font-weight: 400;
		font-size: 16px;
		color: #000000;
		line-height: 28px;
		text-align: left;
		font-style: normal;
		text-transform: none;
		margin-top: 27px;
		margin-left: 37px;
	}
</style>